const KINDS: Record<string, { label: string; image?: boolean; framable?: boolean }> = {
    ".doc": { label: "Word document" },
    ".docx": { label: "Word document" },
    ".pdf": { label: "PDF document", framable: true },
    ".txt": { label: "Text file", framable: true },
    ".jpg": { label: "JPG image", image: true },
    ".jpeg": { label: "JPG image", image: true },
    ".png": { label: "PNG image", image: true },
};

export const extensionOf = (name?: string | null) =>
    (String(name || "").match(/\.[^.]+$/) || [""])[0].toLowerCase();

export const isPreviewableImage = (name?: string | null) =>
    !!KINDS[extensionOf(name)]?.image;

export const isFramable = (name?: string | null) =>
    !!KINDS[extensionOf(name)]?.framable;

export const isWordDocx = (name?: string | null) => extensionOf(name) === ".docx";

export const kindLabelOf = (name?: string | null) =>
    KINDS[extensionOf(name)]?.label || "File";

export const badgeLabelOf = (name?: string | null) =>
    extensionOf(name).replace(".", "").toUpperCase() || "FILE";
